import { getSnowflakesAvailability } from './lib/helpers';
import { SnowflakesAsync } from './SnowflakesAsync';

const isSnowflakesAvailable = getSnowflakesAvailability();

export const SnowflakesWrapper = () => {
    if (!isSnowflakesAvailable) {
        return null;
    }

    return <SnowflakesAsync />;
};
